import { render, staticRenderFns } from "./ApexDonutCharts.vue?vue&type=template&id=8704080a"
import script from "./ApexDonutCharts.vue?vue&type=script&lang=js"
export * from "./ApexDonutCharts.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports